import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import AdvanceDataTable from "../../../components/normal-table/advance-table";
import { ContentWithCardLoading } from "../../../components/loading";
import { CustomSubHeader } from "../../../components/subheader";
import ContentWrapper from "../../Wrapper";
import { Form } from "react-bootstrap";
import _ from "lodash";

const apiCall = (page, limit, search) => new Promise((resolve, reject) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    fetch(`/user-service/api/super-admin/billing/get-payment-logs?page=${page}&limit=${limit}&search=${search}`, requestOptions)
        .then(response => response.text())
        .then(result => resolve(result))
        .catch(error => reject(error));
})

export default function PaymentLogList() {
    const [loading, setLoading] = useState(false);
    const [limit, setLimit] = useState(10);
    const [pageNo, setPageNo] = useState(1);
    const [search, setSearch] = useState("");
    const [data, setData] = useState([]);
    const [count, setCount] = useState(0);
    const dispatch = useDispatch();

    const history = useHistory();


    // useEffect(() => {
    //     dispatch(whatsAppAccountActions.getListOfWhatsAppAccountsRequest({ limit, offset, search, filterTestAccounts: hideTestAccounts }));
    // }, [dispatch, search, pageNo, limit, offset, hideTestAccounts]);

    useEffect(() => {
        doApiCall(1, 10, "");
    }, []);

    const debouncedSearch = useCallback(
        _.debounce((searchText) => {
            doApiCall(1, limit, searchText);
        }, 500),
        [dispatch, limit]
    );

    const doApiCall = (pageNo, limit, search) => {
        setLoading(true);
        apiCall(pageNo, limit, search).then((res) => {
            const data = JSON.parse(res);
            setData(data.data);
            setCount(data.count);
            setLoading(false);
        }).catch((err) => {
            setLoading(false);
            setData([]);
            setCount(0);
        })
    };

    const handleSearchChange = (e) => {
        const searchText = e.target.value;
        setSearch(searchText);
        setPageNo(1);
        debouncedSearch(searchText);
    };

    const handlePageChange = (page) => {
        setPageNo(page);
        doApiCall(page, limit, search);
    };


    return (
        <ContentWrapper subHeader={<CustomSubHeader>
            <div className="d-flex w-100 flex-stack" style={{ justifyContent: 'flex-end' }}>
                <div className="w-300px">
                    <Form.Control
                        value={search}
                        onChange={handleSearchChange}
                        placeholder="Search here..."
                    />
                </div>
            </div>
        </CustomSubHeader>}>
            {loading ? (
                <ContentWithCardLoading />
            ) : data.length === 0 ? (
                "No data"
            ) : (
                <div className={`card card-custom`}>
                    <div className="card-body py-3 px-3" style={{ padding: 15 }}>
                        <AdvanceDataTable
                            columns={[
                                { title: "Account Name", apiKeyName: "accountName", fieldInputType: "INPUT" },
                                { title: "Email", apiKeyName: "email", fieldInputType: "INPUT" },
                                { title: "Payment Method", apiKeyName: "paymentMethod", fieldInputType: "INPUT" },
                                { title: "Payment Intent Id", apiKeyName: "paymentIntentId", fieldInputType: "INPUT" },
                                { title: "Currency", apiKeyName: "currency", fieldInputType: "INPUT" },
                                { title: "Total Price", apiKeyName: "totalPrice", fieldInputType: "INPUT" },
                                { title: "Status", apiKeyName: "status", fieldInputType: "INPUT" },
                                { title: "Receipt Id", apiKeyName: "receiptId", fieldInputType: "INPUT" },
                                { title: "Created At", apiKeyName: "createdAt", fieldInputType: "DATE_TIME" },
                                { title: "Service", apiKeyName: "service", fieldInputType: "INPUT" },
                                { title: "User Per Account", apiKeyName: "action", fieldInputType: "INPUT", isAction: true, options: ["enter"] },
                            ]}
                            data={data}
                            limit={limit}
                            pageNo={pageNo}
                            setLimit={setLimit}
                            setPageNo={handlePageChange}
                            count={count}
                            // actions
                            handleEnter={(data) => history.push(`/accounts/${data.accountId}/campaigns`)}
                        />
                    </div>
                </div>
            )}
        </ContentWrapper>
    );
}
